import React from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';




export default class EmployeeProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userD: {},
            loaded: false,
            error: false,
            isSubmited: false,
            editingProfile: false,
        };
    }

    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };


    componentDidMount() {
        this.getUserData();
    }

    componentDidUpdate() {
        if(this.state.isSubmited === true) {
            this.getUserData();
            this.setState({
                isSubmited: false,
                editingProfile: false,
            })
        }
    }

    getUserData() {
        return new Promise((resolve, reject) => {
            request.get(`/api/user`)
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        loaded: true,
                    });
                    resolve(resp.body);
                })
                .catch(err => {
                    console.error('error', err);
                    this.setState({error: true});
                })

        });
    }

    render() {

        //console.log('user', this.state.userD);

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().required('This value is required.').email('This value should be a valid email.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            //phone: Yup.string().required('This value is required.'),
        });

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];



        let hearAboutNoon = "";
        if(this.state.loaded === true) {
            if(this.state.userD.cdata.additional_information_hearAboutNoon != null && this.state.userD.cdata.additional_information_hearAboutNoon != "" && this.state.userD.cdata.additional_information_hearAboutNoon != "undefind") {
                hearAboutNoon = this.state.userD.cdata.additional_information_hearAboutNoon.split(',');
            }
        }



        return (
            <section>
                {this.state.loaded === true ?
                    <div className='profile-data'>
                        <div className='short-desc'>
                            <h3>Profile</h3>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                        </div>

                        <div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            {this.state.editingProfile === true ?
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.userD.cdata.first_name,
                                        last_name: this.state.userD.cdata.last_name,
                                        phone: this.state.userD.cdata.phone,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                    }}
                                    enableReinitialize={false}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }

                                        return new Promise((resolve, reject) => {
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                    phone: values.phone,
                                                })
                                                .then(data => {
                                                    //console.log('finished user call');
                                                   // console.log(data);
                                                    this.setState({
                                                        isSubmited: true,
                                                    });

                                                })
                                                .catch(err => {
                                                    console.error(err);
                                                    this.setState({isError: true});
                                                });
                                        });
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          resetForm,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            {this.state.isError === true ?
                                                <p className='submission-error-text'>Ooops something went wrong! Please
                                                    try
                                                    again later</p> :
                                                null
                                            }

                                            <button className='form-f-button' type="submit">
                                                Save Profile
                                            </button>
                                            {dirty ?
                                                <a className='form-cancel-button' type="cancel"
                                                   disabled={isSubmitting}
                                                   onClick={handleReset}>
                                                    Reset Form
                                                </a> :
                                                <a className='form-cancel-button' type="cancel"
                                                   disabled={isSubmitting}
                                                   onClick={this.editProfile}>
                                                    Cancel
                                                </a>
                                            }

                                        </Form>
                                    )}
                                </Formik> :
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.userD.cdata.first_name,
                                        last_name: this.state.userD.cdata.last_name,
                                        phone: this.state.userD.cdata.phone,
                                        additional_information_hearAboutNoon: hearAboutNoon,
                                    }}
                                    enableReinitialize={false}
                                    validationSchema={ProfileSchema}
                                    onSubmit={(values, actions) => {

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }

                                        return new Promise((resolve, reject) => {
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                    first_name: values.first_name,
                                                    last_name: values.last_name,
                                                    additional_information_hearAboutNoon: hearedAbout,
                                                    phone: values.phone,
                                                })
                                                .then(data => {
                                                   // console.log('finished user call');
                                                   // console.log(data);
                                                    this.setState({
                                                        isSubmited: true,
                                                        loaded: false,

                                                    });

                                                })
                                                .catch(err => {
                                                    console.error(err);
                                                    this.setState({isError: true});
                                                });
                                        });
                                    }}>
                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          resetForm,
                                          dirty,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                disabled={true}
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            disabled={true}
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            disabled={true}
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                disabled={true}
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <div className='box--outline-comp'>
                                                <div className='checkbox-group-content'>
                                                    <FieldArray
                                                        name='additional_information_hearAboutNoon'
                                                        render={arrayHelpers => (
                                                            <div>
                                                                {refferalOpts.map(option => (
                                                                    <div key={option.id}>
                                                                        <input
                                                                            disabled={true}
                                                                            name='additional_information_hearAboutNoon'
                                                                            type='checkbox'
                                                                            value={option.id}
                                                                            checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                            onChange={event => {
                                                                                if (event.target.checked) {
                                                                                    arrayHelpers.push(option.id);
                                                                                }
                                                                                else {
                                                                                    const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                    arrayHelpers.remove(idx);
                                                                                }
                                                                            }}
                                                                        /> {option.display}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                        </Form>
                                    )}
                                </Formik>
                            }
                        </div>
                    </div>:
                    <Loader/>
                }
            </section>
        )

    }
}




// WEBPACK FOOTER //
// ./src/routes/UserProfile/EmployeeProfile.js